



































import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderCoverPhotoModal, {
  CoverPhoto,
  CoverPhotoFile,
} from '@/components/builder/BuilderCoverPhotoModal.vue'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import { ProfileStubState } from './BuilderProfile.vue'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderAddButton,
    BuilderCoverPhotoModal,
    BuilderButton,
    BuilderTooltip,
    BuilderDot
  },
})
export default class BuilderProfilePageCover extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ProfileStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  processing = false

  open = false

  type: 1 | 3 = 3

  get cover(): CoverPhoto {
    return {
      type: this.type,
      files: !this.value.cover.length
        ? Array.from(new Array(3)).map((_, i) => ({ id: -i - 1, file: null }))
        : this.value.cover,
    }
  }

  set cover(value: CoverPhoto) {
    this.type = value.type
    this.$emit('input', { cover: value.files })
  }

  get isNextStepDisabled(): boolean {
    return !this.cover.files.length || !this.cover.files.every((f: CoverPhotoFile) => !!f.file)
  }

  async onNextClick(): Promise<void> {
    this.processing = true

    try {
      await this.$store.dispatch('builder/setProfileCover', {
        cover: this.cover.files.map((f) => (f.file instanceof File ? f.file : f.id)),
      })

      this.$emit('next')
    } catch (e: any) {
      this.$toasted.error(e.message)
    }

    this.processing = false
  }

  async mounted(): Promise<void> {
    this.$emit('input', {
      highlight: 'cover',
      blurProfile: false,
      blurSubscriptions: true,
      blurContentType: true,
      blurPosts: true
    })
    if(this.value?.cover.length === 1) {
      this.type = 1
    }
  }
}
